module.exports = __parcel__import__.meta.resolve("lhl2J");